import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputModule } from '@sla-ng/ui-material';
import { JoinCostCenterCostCenterDialogComponent } from './join-cost-center-cost-center-dialog.component';

export * from './join-cost-center-cost-center-dialog.component';
@NgModule({
    declarations: [ JoinCostCenterCostCenterDialogComponent ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        GenericInputModule,
        TranslateModule,
    ],
})
export class JoinCostCenterCostCenterDialogModule {
}
